@if (showHeader) {
	@if (setFilter) {
		<div class="filter-wrapper">
			<p>{{ "i18n.codelist_filter.set" | translate }}&#58;</p>
			@if (setFilter) {
				<mat-chip-set>
					<mat-chip class="info">
						{{ setFilter.code }}
						{{ "i18n.codelist_filter." + setFilter.operator | translate }}
						{{ setFilter.criterium }}
					</mat-chip>
				</mat-chip-set>
			}
		</div>
	}
}

<table mat-table class="expandable-table desktop-view breakpoint-md" matSort [dataSource]="dataSource" multiTemplateDataRows aria-label="table">
	<ng-container [matColumnDef]="COLUMN_VALUE">
		<th mat-header-cell mat-sort-header *matHeaderCellDef>
			{{ "i18n.property.code_value" | translate }}
		</th>
		<td mat-cell *matCellDef="let element">
			<span>{{ element.value ?? "-" }}</span>
		</td>
	</ng-container>

	<ng-container [matColumnDef]="COLUMN_NAME">
		<th mat-header-cell mat-sort-header *matHeaderCellDef>
			{{ "i18n.property.name" | translate }}
		</th>
		<td mat-cell *matCellDef="let element">
			{{ (element.name | fallback: currentLanguage) ?? "-" }}
		</td>
	</ng-container>

	<ng-container [matColumnDef]="COLUMN_VALIDFROM">
		<th mat-header-cell *matHeaderCellDef>{{ "i18n.property.valid_from" | translate }}</th>
		<td mat-cell *matCellDef="let element">
			{{ getFormattedDate(element?.validFrom) }}
		</td>
	</ng-container>

	<ng-container [matColumnDef]="COLUMN_VALIDTO">
		<th mat-header-cell *matHeaderCellDef>{{ "i18n.property.valid_to" | translate }}</th>
		<td mat-cell *matCellDef="let element">
			{{ getFormattedDate(element?.validTo) }}
		</td>
	</ng-container>

	<ng-container [matColumnDef]="COLUMN_PARENTCODE">
		<th mat-header-cell mat-sort-header *matHeaderCellDef>
			{{ "i18n.property.parent_code" | translate }}
		</th>
		<td mat-cell *matCellDef="let element">
			<span>{{ element.parentCode ?? "-" }}</span>
		</td>
	</ng-container>

	<ng-container [matColumnDef]="COLUMN_ADDITIONALINFO">
		<th mat-header-cell *matHeaderCellDef>
			{{ "i18n.title.additional_info" | translate }}
		</th>
		<td mat-cell *matCellDef="let element">
			<button mat-icon-button obButton="tertiary" aria-label="expand row" (click)="toggleDetail(element)">
				@if (expandedElement() !== element) {
					<mat-icon svgIcon="chevron_down" class="ob-icon iconsize"></mat-icon>
				}
				@if (expandedElement() === element) {
					<mat-icon svgIcon="chevron_up" class="ob-icon iconsize"></mat-icon>
				}
			</button>
		</td>
	</ng-container>

	<ng-container matColumnDef="expandedDetail">
		<td mat-cell *matCellDef="let element" [attr.colspan]="displayedColumns.length">
			<div class="element-detail">
				<div class="expand-container" [class.expanded]="expandedElement() === element">
					<div class="expand-container-content">
						@if (getFormattedConceptCodeIriPattern(element); as formattedConceptCodeIri) {
							<div>
								<div class="font-weight-600 element-detail-row">{{ "i18n.property.iri_permalink" | translate }}</div>
								{{ formattedConceptCodeIri }}
								<button
									mat-icon-button
									obButton="secondary"
									matTooltip="{{ 'i18n.tooltip.copy_iri_permalink' | translate }}"
									[cdkCopyToClipboard]="formattedConceptCodeIri"
								>
									<mat-icon svgIcon="copy"></mat-icon>
								</button>
							</div>
						}
						<div class="font-weight-600 element-detail-row">{{ "i18n.property.description" | translate }}</div>
						@let description = element?.description | extendedfallback: currentLanguage;
						<div class="element-detail-row" [attr.lang]="description && description.cultureCode !== currentLanguage ? description.cultureCode : null">
							<app-multiline-rich-text [text]="(description?.text | texttolink) ?? '-'"></app-multiline-rich-text>
						</div>
						<div class="font-weight-600 element-detail-row">{{ "i18n.title.annotations" | translate }}</div>
						<app-table-annotation class="element-detail-row" [annotations]="element.annotations ?? []"></app-table-annotation>
					</div>
				</div>
			</div>
		</td>
	</ng-container>

	<tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
	<tr mat-row *matRowDef="let element; columns: displayedColumns" class="element-row"></tr>
	<tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="detail-row"></tr>
</table>

<div class="mobile-view breakpoint-md">
	@for (element of dataSource.data; track element) {
		<div class="wrapper plain">
			<div class="row">
				<div class="label">{{ "i18n.property.code_value" | translate }}</div>
				<div class="value">{{ element.value ?? "-" }}</div>
			</div>
			<div class="row">
				<div class="label">{{ "i18n.property.name" | translate }}</div>
				<div class="value">{{ (element.name | fallback: currentLanguage) ?? "-" }}</div>
			</div>
			<div class="row">
				<div class="label">{{ "i18n.property.valid_from" | translate }}</div>
				<div class="value">{{ getFormattedDate(element?.validFrom) }}</div>
			</div>
			<div class="row">
				<div class="label">{{ "i18n.property.valid_to" | translate }}</div>
				<div class="value">{{ getFormattedDate(element?.validTo) }}</div>
			</div>
			<div class="row">
				<div class="label">{{ "i18n.property.parent_code" | translate }}</div>
				<div class="value">{{ element.parentCode ?? "-" }}</div>
			</div>
			<div class="row">
				<div class="label">{{ "i18n.title.additional_info" | translate }}</div>
				<div class="value">
					<button mat-icon-button obButton="tertiary" aria-label="expand row" (click)="toggleDetail(element)">
						@if (expandedElement() !== element) {
							<mat-icon svgIcon="chevron_down" class="ob-icon iconsize"></mat-icon>
						}
						@if (expandedElement() === element) {
							<mat-icon svgIcon="chevron_up" class="ob-icon iconsize"></mat-icon>
						}
					</button>
				</div>
			</div>
			<div class="row">
				<div class="full-width">
					<div class="element-detail">
						<div class="expand-container" [class.expanded]="expandedElement() === element">
							<div class="expand-container-content">
								@if (getFormattedConceptCodeIriPattern(element); as formattedConceptCodeIri) {
									<div>
										<div class="font-weight-600 element-detail-row">{{ "i18n.property.iri_permalink" | translate }}</div>
										{{ formattedConceptCodeIri }}
										<button
											mat-icon-button
											obButton="secondary"
											matTooltip="{{ 'i18n.tooltip.copy_iri_permalink' | translate }}"
											[cdkCopyToClipboard]="formattedConceptCodeIri"
										>
											<mat-icon svgIcon="copy"></mat-icon>
										</button>
									</div>
								}
								<div class="font-weight-600 element-detail-row">{{ "i18n.property.description" | translate }}</div>
								@let description = element?.description | extendedfallback: currentLanguage;
								<div class="element-detail-row" [attr.lang]="description && description.cultureCode !== currentLanguage ? description.cultureCode : null">
									<app-multiline-rich-text [text]="(description?.text | texttolink) ?? '-'"></app-multiline-rich-text>
								</div>
								<div class="font-weight-600 element-detail-row">{{ "i18n.title.annotations" | translate }}</div>
								<app-table-annotation class="element-detail-row" [annotations]="element.annotations ?? []"></app-table-annotation>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	}
</div>

<div class="table-info-box">
	<app-infobox-no-content [datasource]="dataSource.data"></app-infobox-no-content>
</div>
